import { FC, memo } from 'react';

import { ColumnProps } from './types/ColumnProps';

const ColumnComponent: FC<ColumnProps> = () => <>column</>;

export const Column = memo(ColumnComponent);
